import { z } from 'zod';

/**
 * Warehouse Master DTO.
 *
 * Backend endpoint: `/api/warehouses`. Each row represents a physical
 * storage location (A倉/B倉/C倉/…) that operators assign to inbound
 * packages on the inbound dialog. CRUD endpoints mirror
 * `/api/package-types`; mutations are manager-only.
 */

export const warehouseSchema = z.object({
  warehouse_id: z.string(),
  code: z.string(),
  display_name: z.string(),
  facility_id: z.string().nullable().optional(),
  active_flag: z.boolean(),
  sort_order: z.number().int().nullable().optional(),
  notes: z.string().nullable().optional(),
});

export type Warehouse = z.infer<typeof warehouseSchema>;

export const warehouseCreateSchema = z.object({
  code: z.string().min(1, 'コードを入力してください'),
  display_name: z.string().min(1, '表示名を入力してください'),
  // The backend refuses an active warehouse without a facility, so require the
  // pick up front instead of bouncing the submit.
  facility_id: z.string().min(1, '作業拠点を選択してください'),
  sort_order: z.coerce.number().int().min(0).optional(),
  notes: z.string().optional(),
});

export type WarehouseCreateInput = z.infer<typeof warehouseCreateSchema>;

export const warehouseUpdateSchema = warehouseCreateSchema.partial().extend({
  active_flag: z.boolean().optional(),
});
export type WarehouseUpdateInput = z.infer<typeof warehouseUpdateSchema>;
